module.exports = __webpack_public_path__ + "img/exclamation-triangle.f428f8d0.svg";